import type { FunctionComponent } from 'react';

import { useRegisterAiContext } from '~/shared/ai-context';
import { useApplicationContext } from '~/shared/context/use-application-context';

import { sanitizeSearchParamsForAiContext } from './sanitize-search-params';

export const AutomaticAiContextCollector: FunctionComponent = () => {
    const { applicationState } = useApplicationContext();
    const { languageKey, location, myUserProfile } = applicationState;

    useRegisterAiContext({
        category: 'navigation',
        data: {
            pathname: location.pathname,
            searchParams: sanitizeSearchParamsForAiContext(location.search),
        },
        key: 'auto.route',
        priority: 'critical',
    });

    useRegisterAiContext({
        category: 'user',
        data: {
            displayName: myUserProfile.mapOr('', (profile) => `${profile.firstName} ${profile.lastName}`),
            userId: myUserProfile.mapOr('', (profile) => profile.id),
        },
        key: 'auto.user',
        priority: 'critical',
    });

    useRegisterAiContext({
        category: 'environment',
        data: {
            locale: languageKey,
        },
        key: 'auto.environment',
        priority: 'medium',
    });

    return null;
};
